export default "__VITE_ASSET__D_z1q5AN__"